cockpitApp.controller('checkoutBottomBarController', [
  '$scope', 'basketHelper',
  function($scope, basketHelper) {
    $scope.redirectToCheckout = function(event) {
      basketHelper.redirectToCheckout(event);
    };
  }
]);
